<template>
  <div class='h-dialogContainer'>
    <div v-for='(set, index) in setting' :key='index' class='row h-row-inputBox'>
      <div class='col-sm-5 h-col-inputBox'>
        <div class='h-inputLit'>{{set.inputName}}:</div>
        <ejs-switch v-model='set.isAct' :checked='set.isAct'></ejs-switch>
      </div>
      <div class='col-sm-7 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.confirmCycle')}}:</div>
        <div class='row'>
          <div class='col-sm-5 nopadding'>
            <ejs-textbox v-model="set.interval"></ejs-textbox>
          </div>
          <div class='col-sm-7 nopadding'>
            <ejs-dropdownlist v-model="set.unit" :fields='listFields' :dataSource='timeList' :placeholder='listPlaceholder'></ejs-dropdownlist>
          </div>
        </div>
      </div>
    </div>
    <div class='h-clear-rowMg'></div>
  </div>
</template>
<script>
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'autoConfirmSetting',
  data() {
    return {
      listPlaceholder: this.$t('Alarm.pleaseChoose'),
      listFields: {
        text: 'name',
        value: 'code'
      },
      timeList: [
        { name: this.$t('Alarm.minute'), code: 'Minute' },
        { name: this.$t('Alarm.hour'), code: 'Hour' },
        { name: this.$t('Alarm.day'), code: 'Day' }
      ],
      setting: [{
        name: 'critical',
        level: 0,
        inputName: `${this.$t('Alarm.alarmLevel_0')}${this.$t('Alarm.alarm')}`,
        interval: '',
        unit: '',
        isAct: false
      }, {
        name: 'major',
        level: 1,
        inputName: `${this.$t('Alarm.alarmLevel_1')}${this.$t('Alarm.alarm')}`,
        interval: '',
        unit: '',
        isAct: false
      }, {
        name: 'minor',
        level: 2,
        inputName: `${this.$t('Alarm.alarmLevel_2')}${this.$t('Alarm.alarm')}`,
        interval: '',
        unit: '',
        isAct: false
      }, {
        name: 'warning',
        level: 3,
        inputName: `${this.$t('Alarm.alarmLevel_3')}${this.$t('Alarm.alarm')}`,
        interval: '',
        unit: '',
        isAct: false
      }]
    };
  },
  methods: {
    getAutoConfirmInfo() {
      this.$axios.get('/lte/ems/fm/alarmcurrent/autoConfirmInfo', {}).then((response) => {
        if (response && response.status === 200) {
          const data = response.data.resultVal.alarmAutoConfirm.confirm;
          for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < this.setting.length; j++) {
              if (data[i].level === this.setting[j].level) {
                this.setting[j].interval = data[i].interval == 36500 ? "" : data[i].interval;
                this.setting[j].unit = data[i].unit;
                this.setting[j].isAct = data[i].isAct;
              }
            }
          }
        }
      });
    },
    getConditionData() {
      const isActMap = {};
      const cycleNumMap = {};
      const cycleMap = {};
      const conditions = {};
      for (let i = 0; i < this.setting.length; i++) {
        this.setting[i].interval = this.setting[i].interval + '';
        this.setting[i].unit = this.setting[i].unit + '';
        if (this.setting[i].interval.trim() === "0" || this.setting[i].interval.trim() === "" || this.setting[i].unit.trim() === "") {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.confirmSettingParameter')});
          return false;
        }
        isActMap[this.setting[i].name] = this.setting[i].isAct ? '1' : '0';
        cycleNumMap[`${this.setting[i].name}Num`] = this.setting[i].interval.trim();
        cycleMap[`${this.setting[i].name}Cycle`] = this.setting[i].unit.trim();
      }
      conditions.isActMap = isActMap;
      conditions.cycleNumMap = cycleNumMap;
      conditions.cycleMap = cycleMap;
      return JSON.stringify(conditions);
    }
  }
};
</script>
